import { BaseMoghimProxyService, MoghimApiProxyResult } from "@core/data/BaseMoghimProxyService";
import { HttpClient } from "@angular/common/http";
import { HttpHandlerArgModel } from "@core/data/http.service";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

@Injectable()
export class MoghimAuthenticationProxy extends BaseMoghimProxyService {
    constructor(http: HttpClient, baseSettings?: HttpHandlerArgModel) {
        super(http,'MoghimAuthentication',baseSettings);   
    }

    public Login(input : TAuth.LoginInputModel) : Observable<MoghimApiProxyResult<TAuth.Login>>
    {
        return this.PostForSingle<TAuth.Login>({
            model : input,
            endPointId : 'login',
            // needToken : false
        });
    }

    public async GetValidToken(input : TAuth.LoginInputModel) : Promise<string>
    {
        var tokenResult = await this.GetToken(input);
        return tokenResult;
    }
}